import { __assign } from "tslib";
import { BaseNavButton } from './base-nav-button/base-nav-button.comp';
import { isHtmlLinkProps } from '../../primitives/link/link.comp';
import * as React from 'react';
var renderBaseNavButton = function (props, type) {
    if (isHtmlLinkProps(props)) {
        return React.createElement(BaseNavButton, __assign({}, props, { className: type }), props.children);
    }
    else {
        return React.createElement(BaseNavButton, __assign({}, props, { className: type }), props.children);
    }
};
export var NavButton = function (props) { return renderBaseNavButton(props, 'primary'); };
export var SecondaryNavButton = function (props) { return renderBaseNavButton(props, 'hollow'); };
//# sourceMappingURL=nav-button.comp.js.map